import { render, staticRenderFns } from "./AddOrEditCompositionInfo.vue?vue&type=template&id=52cc9735&scoped=true"
import script from "./AddOrEditCompositionInfo.vue?vue&type=script&lang=js"
export * from "./AddOrEditCompositionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc9735",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52cc9735')) {
      api.createRecord('52cc9735', component.options)
    } else {
      api.reload('52cc9735', component.options)
    }
    module.hot.accept("./AddOrEditCompositionInfo.vue?vue&type=template&id=52cc9735&scoped=true", function () {
      api.rerender('52cc9735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/treatment/composition/sub/AddOrEditCompositionInfo.vue"
export default component.exports